// @flow
import { waitForLogin, listenToLogout } from './loginHandler'
import { MESSAGE_EVENT_TYPE, SPINNER_WRAPPER_ID } from '../constants'
import { getDeviceInfo } from '@sitebase/device-detector'
import postMessageHandler, { close } from './handlers'
import { createIframe, createSpinner, createWrapper, clearSocket, reloadIframe } from './view'

type StartType = {
  selector: string,
}

// Get DOM element
const getElement = (id: string): HTMLElement => {
  const element = document.getElementById(id)
  if (!element) throw new Error(`Failed to match: ${id}`)
  return element
}

// Disable body scroll
const disableBodyScroll = (): void => {
  const { body } = document
  if (body) {
    body.classList.add('noScroll')
  }
}

// Enable body scroll
const enableBodyScroll = (): void => {
  const { body } = document
  if (body) {
    body.classList.remove('noScroll')
  }
}

// Set class by device
const classByDevice = (): string => {
  const deviceInfo = getDeviceInfo()
  return deviceInfo.isDesktop ? 'isDesktop' : deviceInfo.isTablet ? 'isTablet' : 'isMobile'
}

// Desktop Modal Overlay Listener
const listenOverlay = (): void => {
  const eventType: MouseEventTypes = 'click'
  const eventCallback: MouseEventListener = (e: MouseEvent) => {
    // avoid close when it's loading and user clicks inside the modal
    if (e.target instanceof HTMLElement && e.target.closest && e.target.closest(`#${SPINNER_WRAPPER_ID}`)) {
      return
    }

    close()
    document.removeEventListener(eventType, eventCallback, false)
  }
  document.addEventListener(eventType, eventCallback, false)
}

export async function start({ selector }: StartType): Promise<void> {
  const sbElement = getElement(selector)
  sbElement.classList.add(classByDevice())

  try {
    await waitForLogin()
    disableBodyScroll()
    createSpinner(sbElement)

    const wrapper = createWrapper(sbElement)
    createIframe(wrapper)
    getDeviceInfo().isDesktop && listenOverlay()

    global.addEventListener(MESSAGE_EVENT_TYPE, postMessageHandler, false)

    listenToLogout(reloadIframe)
  } catch {
    close()
  }
}

export function stop() {
  // implementation of custom logic cleanup
  clearSocket()
  global.removeEventListener(MESSAGE_EVENT_TYPE, postMessageHandler, false)
  enableBodyScroll()
}
